// utils/dateRange.js


const COOKIE_NAME = 'month_date_range';
const MAX_AGE_HOURS = 2; // hours


const pad = (n) => n.toString().padStart(2, '0');


const format = (date) => {
  const yyyy = date.getFullYear();
  const mm = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  const hh = pad(date.getHours());
  const mi = pad(date.getMinutes());
  const ss = pad(date.getSeconds());
  return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
};


const startOfCurrentMonth = () => new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0);
const endOfCurrentMonth = () => new Date();
// const endOfCurrentMonth = () => new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0, 23, 59, 59); // fin de mes


const readCookie = (name) => {
  if (typeof document === 'undefined') return null;
  const cookies = document.cookie ? document.cookie.split('; ') : [];
  for (let i = 0; i < cookies.length; i++) {
    const parts = cookies[i].split('=');
    const key = parts.shift();
    const value = parts.join('=');
    if (key === name) return decodeURIComponent(value);
  }
  return null;
};


const writeCookie = (name, value, hours) => {
  if (typeof document === 'undefined') return;
  removeCookie(name);
  const expires = new Date(Date.now() + (hours || MAX_AGE_HOURS) * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};


const removeCookie = (name) => {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};


const buildDefaultRange = () => ({
  desde: format(startOfCurrentMonth()),
  hasta: format(endOfCurrentMonth()),
});


export const getMonthDateRange = () => {
  try {
    const raw = readCookie(COOKIE_NAME);
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.desde && parsed.hasta) return parsed;
      } catch (e) {
        // invalid cookie value -> fallthrough to rebuild
      }
    }


    const defaultRange = buildDefaultRange();
    writeCookie(COOKIE_NAME, JSON.stringify(defaultRange), MAX_AGE_HOURS);
    return defaultRange;
  } catch (err) {
    return buildDefaultRange();
  }
};


export const setMonthDateRange = (desde, hasta, hours = MAX_AGE_HOURS) => {
  const toIso = (v) => {
    if (!v) return null;
    if (v instanceof Date) return format(v);
    if (typeof v === 'string') return v;
    return null;
  };


  const d = toIso(desde);
  const h = toIso(hasta);
  if (!d || !h) throw new Error('Invalid desde/hasta values');


  const payload = { desde: d, hasta: h };
  writeCookie(COOKIE_NAME, JSON.stringify(payload), hours);
  return payload;
};


export const clearMonthDateRange = () => {
  removeCookie(COOKIE_NAME);
};


export default getMonthDateRange;

export const listenMetabaseMessages = (origin = "minimalartco.metabaseapp.com") => {
  if (typeof window === "undefined") return;

  const handler = (event) => {
    // Validar origen para no capturar mensajes de otros iframes
    if (!event.origin.includes(origin)) return;

    const metabaseMsg = event.data?.metabase;
    if (metabaseMsg?.type === "location") {
      const search = metabaseMsg.location?.search;
      if (search) {
        const params = new URLSearchParams(search);

        const desde = params.get("desde");
        const hasta = params.get("hasta");
        if (desde && hasta) {
          setMonthDateRange(desde, hasta);
        }
      }
    }
  };

  window.addEventListener("message", handler);

  // Por si alguna vez querés limpiar el listener
  return () => window.removeEventListener("message", handler);
};